import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OphChipComponent} from './oph-chip.component';

@NgModule({
  declarations: [OphChipComponent],
  imports: [CommonModule],
  exports: [OphChipComponent],
})
export class OphChipModule {}
